import { categories, bodies, details, detailsInfo, searchResults } from './data';
import { delay } from 'Common/utils';

export const loadCategories = () => {
  return delay(500).then(() => {
    if (typeof categories === 'undefined') {
      throw Error('kuku');
    } else {
      return categories;
    }
  });
};

export const loadBodies = (catId) => {
  return delay(500).then(() => {
    if (typeof bodies === 'undefined') {
      throw Error('kuku');
    } else {
      return bodies;
    }
  });
};

export const loadDetail = (id) => {
  return delay(500).then(() => {
    if (typeof details === 'undefined') {
      throw Error('kuku');
    } else {
      return details;
    }
  });
};

export const loadDetailInfo = (id) => {
  return delay(500).then(() => {
    if (typeof detailsInfo === 'undefined') {
      throw Error('kuku');
    } else {
      return detailsInfo;
    }
  });
};

export const search = (searchTerm) => {
  console.log('searching for', searchTerm);
  return delay(500).then(() => {
    return searchResults;
  });
};

export const submitApplication = (value, cb) => {
  console.log('Submitting application with data: ', value);
  return delay(500).then(() => ({
    ok: true,
    body: {
      code: 200,
      status: true,
      message: 'success',
      result: {
        request_id: '40227-s/22',
        token: '84ad92ab8c',
      },
    },
  }));
};

export const fetchGender = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Эркак' },
      { id: 2, value: 'Аёл' },
    ];
  });
};

export const fetchPrivacy = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Ҳа' },
      { id: 2, value: 'Йўқ' },
    ];
  });
};

export const fetchStatus = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Банд-ишлайди' },
      { id: 2, value: 'Ишсиз' },
      { id: 3, value: 'Нафақахўр' },
      { id: 4, value: 'Талаба' },
    ];
  });
};

export const fetchRegions = () => {
  return delay(500).then(() => {
    return { body: JSON.stringify({ 1: 'Toshkent', 2: 'Boshqakent' }) };
  });
};

export const fetchDistricts = (regionId) => {
  return delay(500).then(() => {
    return { body: JSON.stringify({ 1: 'Jidazor', 2: 'Uzumzor' }) };
  });
};

// new endpoints
export const fetchMakhallas = (regionId, districtId) => {
  return delay(500).then(() => {
    return { body: JSON.stringify({ 1: 'Bodomzor', 2: 'Giloszor' }) };
  });
};

export const deleteUploadedFile = (params) => {
  return delay(500).then(() => {
    return {
      ok: true,
      text: JSON.stringify({
        guid: null,
        success: true,
      }),
    };
  });
};

export const sendCode = (phone) => {
  return delay(500).then(() => {
    return {
      ok: true,
    };
  });
};

export const checkCode = (phone, code) => {
  return delay(500).then(() => {
    return {
      ok: true,
    };
  });
};



// WEBPACK FOOTER //
// ./src/apps/authorities/fake-api/api.js